






import Vue from 'vue'
import * as player from '@vimeo/player'
export default Vue.extend({
  props: {
    id: {
      type: String
    },
    maxHeight: {
      type: Number
    },
    privacyId: {
      type: String
    }
  },
  data() {
    return {
      height: '320px',
      fullUrl: 'https://player.vimeo.com/video/'
    }
  },
  methods: {
    setHeight() {
      const vimeo = document.getElementById(this.id)
      if (vimeo) {
        const height = vimeo.offsetWidth * 9/16
        this.height = this.maxHeight ? Math.min(height, this.maxHeight) + 'px' : height + 'px'
      }
    },
    setUrl(){
      this.fullUrl = "https://player.vimeo.com/video/" + this.id;
      window.console.log(this.privacyId)
      if(this.privacyId) this.fullUrl = this.fullUrl + "?h=" + this.privacyId;
    }
  },
  mounted() {
    this.setUrl();
    this.setHeight()
    window.addEventListener('resize', () => {
      this.setHeight()
    })
  }
})
